import type { ReactNode } from "react";
import styles from "./InfoBanner.module.scss";

export interface InfoBannerProps {
  icon: ReactNode;
  children: ReactNode;
  className?: string;
  variant?: "default" | "informative";
}

const InfoBanner = ({ icon, children, className = "", variant = "default" }: InfoBannerProps): JSX.Element => (
  <p className={`${styles.banner} ${variant === "informative" ? styles.informative : ""} ${className}`}>
    <span className={styles.icon} aria-hidden="true">{icon}</span>
    <span>{children}</span>
  </p>
);

export default InfoBanner;
